






























































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  components: {},
  computed: {},
})
export default class OrbitCalendarSvg extends Vue {
  @Prop() title!: string;
}
